<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container">
      <div class="section">
        <div class="columns is-vcentered" v-if="event">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px;" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body has-text-centered">
              <h2 class="title">Signed up successfully</h2>

              <div class="is-block has-text-centered">
                <b-button
                  tag="router-link"
                  class="is-primary is-medium"
                  :to="{ name: 'Home' }"
                >
                  Back to Home
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "JudgeSignedUp",
  data() {
    return {
      loading: false
    };
  },
  async created() {},
  computed: {
    ...mapGetters(["event"])
  }
};
</script>